import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Alpine.data('introductionBanner', () => ({
	init() {
		this.handleParallaxAnimation();
	},
	handleParallaxAnimation() {
		gsap.to(this.$refs.media, {
			duration: 1,
			'clip-path': 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
			scrollTrigger: {
				trigger: this.$root,
				scrub: 0.5,
				start: 'top bottom-=100px',
				end: '85% 50%',
			},
		});
	},
}));
